import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import WccImage from "../assets/wcc.png";

const Clarity = () => {
  return (
    <div className="wcc-container">

      {/* What section */}
      <div className="wcc-section">
        <h2 className="wcc-heading">What is Clarity?</h2>
        <p className="wcc-description">
          For when you need more than a conversation.
        </p>
        <p className="wcc-description">
          Sometimes talking helps.
        </p>
        <p className="wcc-description">
          But sometimes, you need to go deeper.
        </p>
        <p className="wcc-description">
          Clarity connects you with licensed mental health professionals for personalized, meaningful sessions that go beyond listening—into understanding, healing, and growth.
        </p>
        <p className="wcc-description">
          This isn’t quick advice; it’s intentional care, designed around you.
        </p>
      </div>

      {/* How section */}
      <div className="wcc-section">
        <h2 className="wcc-heading">How Clarity works?</h2>

        <p className="wcc-description">Clarity is our therapy-forward offering.</p>
        <p className="wcc-description">
          It’s for those ready to explore what’s underneath—guided by a trusted professional.
        </p>
        <ul className="wcc-list">
          <li>One-on-one sessions with qualified psychologists</li>
          <li>Evidence-based approaches, adapted to your story</li>
          <li>Private, secure, and flexible scheduling</li>
          <li>Available in voice, video, or chat formats</li>
        </ul>

        <h3 className="wcc-subheading">Clarity Is for You If:</h3>
        <ul className="wcc-list">
          <li>You’re facing patterns you want to change</li>
          <li>You’re carrying emotions too big to handle alone</li>
          <li>You want to grow—mentally, emotionally, even spiritually</li>
          <li>You’re looking for structured, ongoing support</li>
        </ul>
      </div>

      {/* Why section */}
      <div className="wcc-section wcc-why">
        <h2 className="wcc-heading">Why Clarity?</h2>
        <div className="wcc-content">
          <div className="wcc-features">
            {[
              "It’s not about what’s “wrong”—it’s about what’s real",
              "Personalized care rooted in psychology, not platitudes",
              "100% confidential & judgment-free",
              "Flexible sessions to fit your pace",
              "You’re not “too much.” Your story deserves space.",
            ].map((text, idx) => (
              <p key={idx} className="wcc-feature">
                <FaCheckCircle className="wcc-icon" /> {text}
              </p>
            ))}
          </div>
          <img
            src={WccImage}
            alt="Clarity Illustration"
            className="wcc-image"
          />
        </div>
      </div>

    </div>
  );
};

export default Clarity;
